import 'react-app-polyfill/ie11.js';
import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import { enableES5 } from 'immer';
import {
    assertValidLocale,
    Locale,
    postVerificationSizeUpdates,
    setOptions,
    setViewModel,
    overrideComponent,
    StudentPersonalInfoViewModel,
} from '@sheerid/jslib';
import { StepErrorComponent } from './components/Steps/StepErrorComponent';
import { StepStudentPersonalInfoComponent } from './components/Steps/StepStudentPersonalInfoComponent';
import { StepPendingComponent } from './components/Steps/StepPendingComponent';
import { StepSuccessComponent } from './components/Steps/StepSuccessComponent';
import { graduationDateValidator } from './lib/Validators/validators';

import './index.css';
import App from './App';

import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { getQueryParamsByName } from './lib/utils/browser';

setOptions(defaultOptions);
googleTagManagerHook();
postVerificationSizeUpdates();
enableES5();

const requestToken = getQueryParamsByName('RequestToken') || '';
const email = getQueryParamsByName('email') || '';
let locale = getQueryParamsByName('locale') || '';

try {
    assertValidLocale(locale as Locale);
} catch (error) {
    locale = 'en-US';
}

graduationDateValidator();

const defaultViewModel: StudentPersonalInfoViewModel = {
    countryChoice: undefined,
    email,
    firstName: '',
    lastName: '',
    birthDate: '',
    localeChoice: {
        value: locale as Locale,
        label: undefined,
    },
    organization: {
        id: 0,
        name: '',
    },
    metadata: {
        graduationDate: '',
        RequestToken: requestToken,
    },
};
setViewModel(defaultViewModel);

if (!requestToken) {
    // @ts-expect-error
    overrideComponent('StepStudentPersonalInfoComponent', StepErrorComponent);
} else {
    // @ts-expect-error
    overrideComponent('StepStudentPersonalInfoComponent', StepStudentPersonalInfoComponent);
}

// @ts-expect-error
overrideComponent('StepPendingComponent', StepPendingComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent);

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
